planner-tooltip-orders-phase
  .detail
    span.group.description(if="{ ttData.description }")
      span.label(style="background: { ttData.colorcode }") {ttData.description.label}
      span.value {ttData.description.value}
    span.group.unit_price(if="{ ttData.unit_price }")
      span.label(style="background: { ttData.colorcode }") {ttData.unit_price.label}
      span.value {Number(ttData.unit_price.value).toLocaleString()} { this.locale().unit_price_suffix }
    span.group.material(if="{ ttData.material }")
      span.label(style="background: { ttData.colorcode }") {ttData.material.label}
      span.value {ttData.material.value}
    span.group.heat_treatment(if="{ ttData.heat_treatment }")
      span.label(style="background: { ttData.colorcode }") {ttData.heat_treatment.label}
      span.value {ttData.heat_treatment.value}
  script(type="typescript").
    this.mixin('orders.planner.tooltip.orders-phase');
  style(scoped).
    .group {
      display: inline-block;
      margin-right: .5rem;
    }
